import { ListItemTextProps, ListItemText as MuiListItemText } from '@mui/material';

type Props = Pick<
  ListItemTextProps,
  'primary' | 'secondary' | 'className' | 'slotProps' | 'children'
>;

const ListItemText = ({ className, primary, secondary, slotProps, children }: Props) => {
  return (
    <MuiListItemText
      className={className}
      primary={primary}
      secondary={secondary}
      slotProps={slotProps}
    >
      {children}
    </MuiListItemText>
  );
};

export default ListItemText;
